import type { CustomerCreditStatement } from '@aeris/contracts'
import { MONEY_SCALE, parseHumanAmount, ZERO_MONEY } from '@aeris/money'
import type { ReceiptVoucher } from '@aeris/printing'

const money = (wire: string) =>
  parseHumanAmount(wire.replace('-', '').replace('.', ','), MONEY_SCALE) ??
  ZERO_MONEY

/**
 * O vale do cliente para o pé da nota (Elite, 15/10): o saldo de agora e o
 * último abatimento. O extrato vem do mais novo para o mais velho; o abatimento
 * é a linha `redeemed`, que o banco guarda negativa.
 */
export const voucherOnReceipt = (
  statement: CustomerCreditStatement | undefined
): ReceiptVoucher | null => {
  if (statement === undefined) return null
  const last = statement.entries.find((entry) => entry.kind === 'redeemed')
  return {
    balance:
      parseHumanAmount(statement.balance.replace('.', ','), MONEY_SCALE) ??
      ZERO_MONEY,
    lastRedeemed:
      last === undefined
        ? null
        : { amount: money(last.amount), at: new Date(last.occurredAt) },
  }
}
